import { Dispatcher as BaseDispatcher } from '../../../../_common/platform/ts/BaseDispatcher';

export class Dispatcher extends BaseDispatcher {
    public handleViewAction<T>(action: T) {
        this.dispatch({
            source: 'VIEW_ACTION',
            action: action
        });
    }

    public static get() {
        return new Dispatcher();
    }
}
